import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import Welcome from "../views/Welcome.vue";
import Booknew from "../views/book-new.vue";
// import Booking from '../views/bookOrder/booking.vue'
import Login from "./../views/auth0/login.vue";
import store from "../store";
import Book from "../views/users/bookingView.vue";
import Enterphone from "../views/auth0/enterphone.vue";
import DashbordStaff from "../views/staff/DashbordStaffView.vue";
import OrderUser from "../views/users/ordersView.vue";
import Myjob from "../views/staff/myjob.vue";
import Bookdrop from "../views/staff/packing.vue";
import Ordersucess from "../views/staff/ordersucess.vue";
// import Neworders from "../views/staff/neworders.vue";
import History from "../views/staff/HistoriesView.vue";
import Ready from "../views/staff/ready.vue";
import MeetingRoom from "../views/staff/MeetingroomView.vue";
import LoginStaff from "../views/auth0/loginStaff.vue";
import Locker from "../views/bookOrder/getpasswordlocker.vue";
import Uploadslide from "../views/layouts/uploadslide.vue";
import Profile from "../views/users/profileView.vue";
import Renew from "../views/users/renewView.vue";
// import Duedate from "../views/users/duedate.vue"
// import Info from "../views/info.vue";
import Loykrathong from "../views/events/loykrathong/loykathong.vue";
import Meeting from "../views/users/meetingroomView.vue";

import events from "../views/events/modalEvent.vue";
import blog from "../views/users/blog.vue";
// import feedback from "../views/users/feedback.vue";
import feedback from "../views/users/feedbacks/feedback.vue";
// import feedbackDetail from "../views/users/feedbacks/feedbackDetailMain.vue";
import LsmartERP from "../views/staff/LsmartERP.vue";
import Staff_Feed from "../views/staff/Feed.vue";
import Enterstd_bookingroom from "../views/users/enterstd_bookingroom.vue";
import Enterstd_rac from "../views/users/enterstd_rec.vue";
import Approve from "../views/staff/approve.vue";
import Qrocde from "../views/staff/qrcode.vue";
import Rate from "../views/users/rate.vue";
import KingDom from "../views/events/kingdom/card-sign.vue";
import Loy from "../views/events/loykrathong/loykathong.vue";
import TestLoy from "../views/events/loykrathong/test_loy.vue";
import MainView from "../views/mainView.vue";
import ActivitiesView from "../views/staff/activitiesView.vue"
import testNewFeed from "../views/mainView.vue";
import Ubrucoffee from "../views/users/ubruCoffeeView.vue";
import UbrucoffeeReturn from "../views/users/ubruCoffeeRetrunView.vue";
import MembershipView from './../views/staff/membershipView.vue'
import testmeeting from './../views/users/meetingRoom.vue'
import aboutView from "../views/users/aboutView.vue";
import returnBookdropView from "../views/users/returnBookdropView.vue";
import BookdropStaff from "../views/staff/bookdropView.vue";
import Createroom from "../components/staff/createroom.vue";

// import UbrucoffeeFitness from './../views/users/ubruCoffeeFitnessView.vue'

Vue.use(VueRouter);

const routes = [
  {path:"/testmeeting",name:"testmeeting",component:testmeeting},
 
  {path:"/about",name:"aboutView",component:aboutView},
  {
    path: "/testloy",
    name: "TestLoy",
    component: TestLoy,
  },
  {
    path: "/loy",
    name: "Loy",
    component: Loy,
  },
  {
    path:"/staff/createroom",
    name:"Createroom",
    component:Createroom
  },
  {
    path:"/returnBookDrop",
    name:"returnBookDropView",
    component:returnBookdropView,
    meta: {
      requiresAuth: false,
      adminAuth: false,
      userAuth: true,
    },
  },
  {
    path: "/ubrucoffeehappiness",
    name: "Ubrucoffee",
    component: Ubrucoffee,
    meta: {
      requiresAuth: false,
      adminAuth: false,
      userAuth: true,
    },
  },
  {
    path: "/testNewFeed",
    name: "testNewFeed",
    component: testNewFeed,
  },
  {
    path: "/activity",
    name: "ActivitiesView",
    component: ActivitiesView,
  },
  {
    path: "/LsmartERP",
    name: "LsmartERP",
    component: LsmartERP,
  },

  {
    path: "/event",
    name: "modalEvent",
    component: events,
  },
  {
    path: "/",
    name: "MainView",
    component: MainView,
  },
  // {
  //   path: "/",
  //   name: "welcome",
  //   component: Welcome,
  // },
  {
      path:'/KingDom',
      name:"KingDom",
      component: KingDom 
  },
  // {
  //   path: "/",
  //   name: "Info",
  //   component: Info,
  // },
  {
    path: "/blog",
    name: "Blog",
    component: blog,
  },
  // {
  //   path: "/feedback:id",
  //   name: "Feedback",
  //   component: feedback,
  // },
  {
    path: "/ubrucoffee",
    name: "Ubrucoffee",
    component: Ubrucoffee,
    meta: {
      requiresAuth: false,
      adminAuth: false,
      userAuth: true,
    },
  },
  {
    path:"/ubrucoffee-return",
    name:"UbrucoffeeReturn",
    component:UbrucoffeeReturn
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: false,
      adminAuth: false,
      userAuth: true,
    },
  },
  // name: "Info",
  //   component: Info,
  //  {
  //   path: "/BookingRoom",
  //   name: "Info",
  //   component: Info,
  // },
  {
    path: "/BookingRoom",
    name: "Meeting",
    component: Meeting,
  },
  {
    path: "/neworders",
    name: "Neworders",
    component: DashbordStaff,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      userAuth: false,
    },
  },
  //
  {
    path:"/membership",
    name:"Membership",
    component: MembershipView 
  },
  {
    path: "/myjob",
    name: "Myjob",
    component: Myjob,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      userAuth: false,
    },
  },
  {
    path: "/staffMeeting",
    name: "Meetingroom",
    component: MeetingRoom,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      userAuth: false,
    },
  },
  {
    path: "/staff-feedback",
    name: "Staff_Feed",
    component: Staff_Feed,
  },
  {
    path: "/bookdrop",
    name: "BookdropStaff",
    component: BookdropStaff,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      userAuth: false,
    },
  },

  {
    path: "/packing",
    name: "Bookdrop",
    component: Bookdrop,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      userAuth: false,
    },
  },
  {
    path: "/ordersucess",
    name: "Ordersucess",
    component: Ordersucess,
  },
  {
    path: "/history",
    name: "History",
    component: History,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      userAuth: false,
    },
  },
  {
    path: "/ready",
    name: "Ready",
    component: Ready,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      userAuth: false,
    },
  },
  {
    path: "/upload",
    name: "Uploadslide",
    component: Uploadslide,
  },
  {
    path: "/staff",
    name: "DashbordStaff",
    component: DashbordStaff,
    meta: {
      requiresAuth: true,
      adminAuth: true,
      userAuth: false,
    },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/newbook",
    name: "Booknew",
    component: Booknew,
  },
  // {
  //   path: "/booking",
  //   name: "Info",
  //   component: Info,
  // },
  {
    path: "/booking",
    name: "Book",
    component: Book,
  },
  {
    path: "/renew",
    name: "Renew",
    component: Renew,
    meta: {
      requiresAuth: false,
      adminAuth: false,
      userAuth: true,
    },
  },
  {
    path: "/loykrathongday",
    name: "Loykrathong",
    component: Loykrathong,
  },
  // {
  //   path: "/duedate",
  //   name: "Duedate",
  //   component: Duedate,
  // },
  {
    path: "/checkOrder",
    name: "OrderUser",
    component: OrderUser,
  },
  {
    path: "/enterphone",
    name: "Enterphone",
    component: Enterphone,
  },
  {
    path: "/locker/:id",
    name: "Locker",
    component: Locker,
  },
  {
    path: "/studio/:id",
    name: "Enterstd_bookingroom",
    component: Enterstd_bookingroom,
  },
  {
    path: "/recordingstudio/:id",
    name: "Enterstd_rac",
    component: Enterstd_rac,
  },
  {
    path: "/approval/:id",
    name: "Approve",
    component: Approve,
    meta: {
      adminAuth: false,
      requiresAuth: false,
      userAuth: false,
    },
  },
  // {
  //   path: "/feedback",
  //   name: "FeedbackDetail",
  //   component: feedbackDetail,
  // },
  {
    path:"/rate/:id",
    name:"Rate",
    component:Rate
  },
  {
    path: "/feedback/:id",
    name: "Feedback",
    component: feedback,
  },
  { path: "/qrcode/:id", name: "Qrcode", component: Qrocde },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresAuth: false,
      adminAuth: true,
      userAuth: true,
    },
  },
  {
    path: "/login-staff",
    name: "LoginStaff",
    component: LoginStaff,
    meta: {
      adminAuth: false,
      requiresAuth: false,
      userAuth: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("auth") != null) {
    let a = JSON.parse(localStorage.getItem("auth"));
    const userType = a.user_type;
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
        if (to.matched.some((record) => record.meta.adminAuth)) {
          if (userType === "Staff") {
            next();
            return;
          } else {
            next("/");
          }
        }

        if (to.matched.some((record) => record.meta.userAuth)) {
          if (userType === "Student" || userType === "Teacher") {
            // router.back();
            next("/");
            return;
          } else {
            next();
          }
        }
      }

      next("/login");
    } else {
      next();
    }
  } else {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!store.getters.isLoggedIn) {
        if (
          to.matched.some((record) => record.meta.adminAuth) ||
          to.matched.some((record) => record.meta.userAuth)
        ) {
          next("login");
        }
      }
      next();
    } else {
      next();
    }
  }
});

export default router;
